export default {
    home_search_for_product: "Cerca il tuo prodotto",
    conventional_alternative: "Alternativa convenzionale",
    led_alternative: "Alternativa LED",
    search_filters_filter: "Filtro",
    alt_filters_filter: "Filtro per le alternative a Led",
    search_submit: "Ricerca prodotto",
    results: "Risultati",
    selected_product: "Prodotto selezionato",
    search_input: "Inserisci il codice o la descrizione del prodotto (anche parziale)",
    what_type_are_you_looking_for: "Che tipo di prodotto sostitutivo stai cercando?",
    recommendations_singular: "Prodotti consigliati",
    recommendations_plural: "Prodotti consigliati",
    your_product: "Il tuo prodotto",
    search_filters_reset: "Azzera i filtri",
    results_specify: "Ci sono più di 10 risultati, per favore specifica ulteriormente la tua ricerca",
    energy_efficient: "Efficenza energetica",
    active_filters: "Filtri attivi",
    card_action: "Catalogo",
    card_show_more: "Mostra di più",
    card_show_less: "Mostra meno",
    card_alternative_fit: "Miglior alternativa Philips",
    card_perfect_fit: "Miglior soluzione Philips",
    no_results_found: "Nessun risultato. Per favore prova ad inserire altri dati di ricerca",
    results_no_recommendations: "Sei bloccato? Per favore contatta un account manager o un rappresentante vendite locale per trovare una soluzione.",
    led_no_recommendations: "Non ci sono alternative a Led per questi prodotti",
    ballast_notice: "Per il reattore elettronico (HF) è necessario verificare la compatibilità del reattore.",
    ballast_notice_tled_link_text: "Lista di compatibilità TLED",
    ballast_notice_pl_led_link_text: "Lista di compatibilità TLED",

    // LED facets
    search_filter_product_type: "Tipo di prodotto",
    lighting_type: "Tipo di lampada",
    ean: "EAN",
    product_code: "Codice prodotto",
    eoc: "EOC",
    family: "Famiglia di prodotto",
    discrete_wattage: "Potenza",
    wattage: "Potenza",
    brand: "Marca",
    driver_type: "Tipo di driver",
    number_of_lamps: "Numero di lampade",
    length: "Lunghezza",
    color: "Colore",
    base: "Base",
    local_eoc: "Codice locale",
    ignitor: "Accensione",
    height: "Altezza",
    width: "Larghezza",
    mounting_hole: "Foro di montaggio",
    mains_voltage: "Tensione di rete",
    thermal_protection: "Protezione termica",
    delta_temperature: "Range di temperatura",
    energy_efficiency: "Efficienza energetica",
    losses: "Perdite",
    lamp_current: "Corrente della lampada",
    pf_cap: "PF Cap",
    lumen: "Flusso Luminoso",
    energy_saving: "Risparmio energetico",
    tiering: "Classificazione",
    ballast_compatibility: "Compatibilità per gli alimentatori",
    lifetime: "Durata di vita",
};
